/**
 * 1. SLIDER LOGIK (MED INFINITE CLONING TIL 2 BILLEDER – INGEN LAGGING ELLER GRÅ HULLER)
 */
function initProductSlider() {
  const wrapper = document.querySelector('.cm-media-wrapper');
  const prevBtn = document.querySelector('.cm-prev');
  const nextBtn = document.querySelector('.cm-next');

  if (!wrapper || !nextBtn || !prevBtn) return;

  const originalItems = wrapper.querySelectorAll('.cm-media-item:not(.cm-js-clone)');
  const originalCount = originalItems.length;

  if (originalCount === 2 && !wrapper.querySelector('.cm-js-clone')) {
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add('cm-js-clone');

      const img = clone.querySelector('img');
      if (img) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'auto');
      }

      wrapper.appendChild(clone);
    });
  }

  let isTransitioning = false;
  const duration = 400;

  const handleNext = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;

    const firstItem = wrapper.firstElementChild;
    if (!firstItem) { isTransitioning = false; return; }

    const width = firstItem.offsetWidth;
    wrapper.style.webkitTransform = 'translateZ(0)';
    wrapper.style.transform = 'translateZ(0)';
    wrapper.style.transition = `margin-left ${duration}ms ease-in-out`;
    wrapper.style.marginLeft = `-${width}px`;

    setTimeout(() => {
      wrapper.style.transition = 'none';
      wrapper.appendChild(firstItem);
      wrapper.style.marginLeft = '0';
      isTransitioning = false;
    }, duration);
  };

  const handlePrev = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;

    const lastItem = wrapper.lastElementChild;
    if (!lastItem) { isTransitioning = false; return; }

    const width = lastItem.offsetWidth;
    wrapper.style.webkitTransform = 'translateZ(0)';
    wrapper.style.transform = 'translateZ(0)';
    wrapper.style.transition = 'none';
    wrapper.prepend(lastItem);
    wrapper.style.marginLeft = `-${width}px`;

    wrapper.offsetHeight;
    wrapper.style.transition = `margin-left ${duration}ms ease-in-out`;
    wrapper.style.marginLeft = '0';

    setTimeout(() => {
      isTransitioning = false;
    }, duration);
  };

  nextBtn.addEventListener('click', handleNext);
  prevBtn.addEventListener('click', handlePrev);

  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;

  wrapper.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchEndX = touchStartX;
    touchEndY = touchStartY;
  }, { passive: true });

  wrapper.addEventListener('touchmove', (e) => {
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;
  }, { passive: true });

  wrapper.addEventListener('touchend', (e) => {
    handleSwipeGesture(e);
  });

  function handleSwipeGesture(e) {
    const xDiff = touchStartX - touchEndX;
    const yDiff = touchStartY - touchEndY;
    const minSwipeDistance = 40;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (Math.abs(xDiff) > minSwipeDistance) {
        if (xDiff > 0) {
          handleNext(e);
        } else {
          handlePrev(e);
        }
      }
    }
    touchStartX = 0; touchEndX = 0; touchStartY = 0; touchEndY = 0;
  }
}

/**
 * 2. BUNDLE/SIZE DRAWER LOGIK
 */
function initBundleDrawer() {
  const bundleBtn = document.getElementById('cm-open-bundle-drawer');
  const bundleDrawer = document.getElementById('cm-bundle-drawer');

  if (!bundleBtn || !bundleDrawer) return;

  const bundleClose = bundleDrawer.querySelector('.cm-bundle-drawer__close');
  const bundleOverlay = bundleDrawer.querySelector('.cm-bundle-drawer__overlay');

  const openBundle = (e) => {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    bundleDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeBundle = (e) => {
    if (e) e.preventDefault();
    bundleDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  bundleBtn.addEventListener('click', openBundle);
  if (bundleClose) bundleClose.addEventListener('click', closeBundle);
  if (bundleOverlay) bundleOverlay.addEventListener('click', closeBundle);

  const sizeButtons = bundleDrawer.querySelectorAll('.cm-size-grid__button');
  sizeButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const parentGrid = this.closest('.cm-size-grid');
      parentGrid.querySelectorAll('.cm-size-grid__button').forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
    });
  });
}

/**
 * 3. BUTIKSLAGER LOGIK (OPDATERET TIL KUN AT VISE VARIANTER + FIX AF PRIK-FARVER)
 */
async function initStoreStock() {
    const trigger = document.querySelector('.location-stock-trigger');
    const dataHolder = document.getElementById('cm-store-data');
    const container = document.getElementById('store-availability');
    const findInStoreRow = document.querySelector('.cm-stock-row');
    const drawer = document.getElementById('cm-store-drawer');
    const drawerTitle = drawer ? drawer.querySelector('.cm-store-drawer__title') : null;

    if (!trigger || !dataHolder || !drawer) return;

    const closeBtn = drawer.querySelector('.cm-store-drawer__close');
    const overlay = drawer.querySelector('.cm-store-drawer__overlay');

    const openDrawer = () => drawer.classList.add('is-open');
    const closeDrawer = () => drawer.classList.remove('is-open');

    if (findInStoreRow) findInStoreRow.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Oversatte tekster leveret af serveren via data-attributter (se cm-store-data
    // divet i sections/cm-main-product*.liquid). Fallback til dansk hvis attributten
    // mangler, så vi aldrig hardkoder sprog direkte i denne statiske .js-fil.
    const i18nSoldOutInStores = dataHolder.dataset.i18nSoldOutInStores || 'Udsolgt i butikkerne';
    const i18nInStock = dataHolder.dataset.i18nInStock || 'På lager';
    const i18nSoldOut = dataHolder.dataset.i18nSoldOut || 'Udsolgt';

    const pIds = JSON.parse(dataHolder.getAttribute('data-product-ids'));
    const query = `query getStock($ids: [ID!]!) {
      locations(first: 10) {
        nodes {
          id
          name
          address { address1 city country }
        }
      }
      nodes(ids: $ids) {
        ... on Product {
          title
          variants(first: 100) {
            nodes {
              title
              id
              storeAvailability(first: 10) {
                nodes { available location { id } }
              }
            }
          }
        }
      }
    }`;

    try {
        const response = await fetch('https://suiteclub-dk.myshopify.com/api/2024-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'c4155773b96479184bb99811dc2dc6aa',
            },
            body: JSON.stringify({ query, variables: { ids: pIds } }),
        });

        const result = await response.json();
        const allLocations = result.data.locations.nodes;
        const locations = allLocations.filter(l => l.name !== 'Lager Aarhus');
        const products = result.data.nodes.filter(n => n);

        // --- HÅNDTERING AF ONLINE LAGER STATUS (Inkluderer 'Lager Aarhus') ---
        const onlineIcon = document.querySelector('.product-stock__icon');
        const hasOnlineStock = allLocations.some(loc => {
            return products.some(p => p.variants.nodes.some(v =>
                v.storeAvailability.nodes.some(a => a.location.id === loc.id && a.available)
            ));
        });

        if (onlineIcon) {
            onlineIcon.style.backgroundColor = hasOnlineStock ? '#008b00' : '#8b0000';
        }

        // --- HÅNDTERING AF BUTIKS LAGER STATUS (Ekskluderer 'Lager Aarhus') ---
        const availableStoreLocations = locations.filter(loc => {
            return products.some(p => p.variants.nodes.some(v =>
                v.storeAvailability.nodes.some(a => a.location.id === loc.id && a.available)
            ));
        });

        const totalLocations = availableStoreLocations.length;

        if (drawerTitle) {
            drawerTitle.textContent = totalLocations > 0
                ? `På lager i ${totalLocations} butik(ker)`
                : i18nSoldOutInStores;
        }

        if (trigger) {
            trigger.textContent = `På lager i ${totalLocations} butik(ker)`;
            const storeIcon = findInStoreRow.querySelector('#stock_icon');
            if (storeIcon) {
                storeIcon.style.backgroundColor = totalLocations > 0 ? '#008b00' : '#8b0000';
            }
        }

        // --- GENERERING AF SKUFFE-HTML (Udelukkende den med Varianter) ---
        if (container) {
            container.innerHTML = '';

            locations.forEach(location => {
                const locationCard = document.createElement('div');
                locationCard.className = 'location-card';
                locationCard.style.cssText = "border-bottom: 1px solid #eee; padding: 20px;";

                const locationTitleCard = `
                  <div class="location-title-card" style="display:flex; justify-content:space-between; align-items:center;">
                    <h3 class="location-name" style="margin:0; font-size:16px;">${location.name}</h3>
                    <div class="book-tid-lagerstatus" style="display:flex; align-items:center; gap:5px;">
                      <a href="https://suitclub.dk/pages/book-tid" style="text-decoration:underline; font-size:13px; color:#34342f;">Book en tid</a>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 6L15 12L9 18" stroke="#34342f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                `;
                locationCard.innerHTML += locationTitleCard;

                const address = `<p class="location-address" style="color:#666; font-size:14px; margin:5px 0;">${location.address.address1 || ''}, ${location.address.city || ''}</p>`;
                locationCard.innerHTML += address;

                products.forEach(product => {
                    const allSoldOut = product.variants.nodes.every(variant =>
                        variant.storeAvailability.nodes.every(availability =>
                            availability.location.id !== location.id || !availability.available
                        )
                    );

                    const stockStatusColor = allSoldOut ? '#8b0000' : '#008b00';
                    const stockStatusText = allSoldOut ? `● ${i18nSoldOut}` : `● ${i18nInStock}`;

                    const productInfo = `
                        <div class="product-information-drawer__tstock" style="display:flex; justify-content:space-between; margin-top:10px;">
                          <h4 class="product-name" style="margin:0; font-size:14px; font-weight:normal;">${product.title}</h4>
                          <span class="stock-status" style="color:${stockStatusColor}; font-size:14px;">${stockStatusText}</span>
                        </div>
                    `;

                    const variantButtons = product.variants.nodes.length > 1 ||
                    (product.variants.nodes.length === 1 && product.variants.nodes[0].title !== 'Default Title')
                    ? `
                      <div class="variant-buttons" style="display:flex; gap:5px; flex-wrap:wrap; margin-top:8px;">
                        ${product.variants.nodes
                          .filter(variant =>
                            variant.storeAvailability.nodes.some(availability =>
                              availability.location.id === location.id && availability.available
                            )
                          )
                          .map(variant => `<span class="variants cm-stock-variants" data-product-id="${variant.id}" style="border:1px solid #ccc; padding:3px 8px; font-size:12px; border-radius:4px;">${variant.title}</span>`).join('')}
                      </div>
                    `
                    : '';

                    locationCard.innerHTML += productInfo + variantButtons;
                });

                container.appendChild(locationCard);
            });
        }
    } catch (e) { console.error("Lagerfejl:", e); }
}

/**
 * 4. COLLECTION DRAWER LOGIK
 */
function initCollectionDrawer() {
  const drawerDesk = document.getElementById('cm-collection-drawer-desktop');
  const drawerMob = document.getElementById('cm-collection-drawer-mobile');

  document.addEventListener('click', function(e) {
    const triggerMob = e.target.closest('#cm-open-collection-drawer-mobile');
    if (triggerMob && drawerMob) {
      e.preventDefault();
      e.stopPropagation();
      drawerMob.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return;
    }

    const triggerDesk = e.target.closest('#cm-open-collection-drawer-desktop');
    if (triggerDesk && drawerDesk) {
      e.preventDefault();
      e.stopPropagation();
      drawerDesk.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return;
    }

    if (e.target.closest('.cm-collection-drawer__close') || e.target.closest('.cm-store-drawer__close')) {
      const activeDrawer = e.target.closest('.cm-store-drawer.is-open');
      if (activeDrawer) {
        e.stopPropagation();
        activeDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    if (e.target.matches('.cm-store-drawer__overlay')) {
      const activeDrawer = e.target.closest('.cm-store-drawer.is-open');
      if (activeDrawer) {
        activeDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });
}

/**
 * 5. SHOP THE LOOK LOGIK
 */
function initShopLookDrawer() {
  const lookBtns = document.querySelectorAll('.cm-shop-the-look');
  const shopLookDrawer = document.getElementById('cm-shop-look-drawer');

  if (lookBtns.length === 0 || !shopLookDrawer) return;

  const closeBtn = shopLookDrawer.querySelector('.cm-store-drawer__close');
  const overlay = shopLookDrawer.querySelector('.cm-store-drawer__overlay');

  lookBtns.forEach(lookBtn => {
    lookBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      shopLookDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });

  const closeShopLook = () => {
    shopLookDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (closeBtn) closeBtn.addEventListener('click', closeShopLook);
  if (overlay) overlay.addEventListener('click', closeShopLook);

  const atcButtons = shopLookDrawer.querySelectorAll('.atc-btn');

  atcButtons.forEach(atcBtn => {
    atcBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const targetId = atcBtn.getAttribute('data-bundle-id');
      const targetDrawer = document.getElementById(targetId);

      if (targetDrawer) {
        shopLookDrawer.classList.remove('is-open');
        targetDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        const sClose = targetDrawer.querySelector('.cm-bundle-drawer__close') || targetDrawer.querySelector('.cm-store-drawer__close');
        const sOverlay = targetDrawer.querySelector('.cm-bundle-drawer__overlay') || targetDrawer.querySelector('.cm-store-drawer__overlay');
        const atcActionBtn = targetDrawer.querySelector('.cm-add-to-cart-action');
        const sizeBtns = targetDrawer.querySelectorAll('.cm-size-button:not([disabled])');

        const closeSpecific = () => {
          targetDrawer.classList.remove('is-open');
          document.body.style.overflow = '';
        };

        if (sClose) sClose.onclick = closeSpecific;
        if (sOverlay) sOverlay.onclick = closeSpecific;

        if (atcActionBtn) {
          atcActionBtn.removeAttribute('data-selected-variant');
          const textSpan = atcActionBtn.querySelector('.cm-atc-text');
          if (textSpan) {
            // Gemmer den server-renderede (oversatte) knap-tekst første gang vi
            // rammer denne knap, så vi altid kan nulstille til den korrekte
            // sprogversion i stedet for at hardkode dansk tekst her. Hardkodet
            // dansk tekst her overskrev tidligere den oversatte tekst fra
            // produkt-skabelonen på alle andre markeder end Danmark (fx tysk).
            if (!atcActionBtn.dataset.cmDefaultAtcText) {
              atcActionBtn.dataset.cmDefaultAtcText = textSpan.textContent.trim();
            }
            textSpan.innerText = atcActionBtn.dataset.cmDefaultAtcText;
          }
        }

        sizeBtns.forEach(sb => {
          sb.onclick = function() {
            sizeBtns.forEach(b => b.classList.remove('is-active'));
            this.classList.add('is-active');
            const variantId = this.getAttribute('data-variant-id');
            if (atcActionBtn) atcActionBtn.setAttribute('data-selected-variant', variantId);
          };
        });

        if (atcActionBtn && !atcActionBtn.dataset.hasListener) {
          atcActionBtn.dataset.hasListener = "true";
          atcActionBtn.addEventListener('click', function() {
            const variantId = this.getAttribute('data-selected-variant');
            const textSpan = this.querySelector('.cm-atc-text');

            if (!variantId) {
              alert(this.dataset.cmSelectSizeAlert || 'Venligst vælg en størrelse først.');
              return;
            }

            if (textSpan) textSpan.innerText = this.dataset.cmAddingText || 'Tilføjer...';
            this.disabled = true;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            })
            .then(response => {
              if (!response.ok) throw new Error('Netværksfejl');
              return response.json();
            })
            .then(formData => {
              if (textSpan) textSpan.innerText = this.dataset.cmAddedText || '✓ Tilføjet';

              document.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: formData }
              }));

              const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(formData);
              } else if (cartDrawer) {
                cartDrawer.classList.add('is-open');
              }

              fetch(window.Shopify.routes.root + 'cart.js')
                .then(res => res.json())
                .then(cart => {
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: { product: formData, cart: cart }
                  }));
                });

              setTimeout(() => {
                closeSpecific();
                this.disabled = false;
                if (textSpan) textSpan.innerText = this.dataset.cmDefaultAtcText || textSpan.innerText;
              }, 800);
            })
            .catch(error => {
              console.error('Fejl ved AJAX tilføjelse:', error);
              if (textSpan) textSpan.innerText = this.dataset.cmErrorText || 'Fejl! Prøv igen';
              this.disabled = false;
            });
          });
        }
      }
    });
  });
}

/**
 * 6. MTM DRAWER LOGIK
 */
function initMtmDrawer() {
  const trigger = document.querySelector('[data-cm-mtm-trigger]');
  const drawer = document.querySelector('.cm-store-drawer[id^="cm-mtm-overlay"]');

  if (!trigger || !drawer) return;

  const closeBtn = drawer.querySelector('.cm-mtm-drawer__close');
  const overlay = drawer.querySelector('.cm-store-drawer__overlay');

  const openDrawer = (e) => {
    e.preventDefault();
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  trigger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
}

/**
 * 7. INFINITE LOOP MEDIA LOGIK
 */
function initProductInfiniteLoop() {
  const wrapper = document.querySelector('.cm-media-wrapper');
  if (!wrapper) return;

  const productMediaEl = document.querySelector('product-media');
  const isBelt = productMediaEl ? productMediaEl.getAttribute('data-is-belt') === 'true' : false;

  if (isBelt) return;

  const desktopBreakpoint = 1800;
  let isLooping = false;
  let animationTimeout;

  const setupInfiniteLoop = () => {
    wrapper.querySelectorAll('.cm-js-duplicate').forEach(el => el.remove());
    const items = wrapper.querySelectorAll('.cm-media-item:not(.cm-js-duplicate)');

    if (items.length <= 1) return;

    if (items.length < 5) {
      const targetCount = 12;
      const iterationsNeeded = Math.ceil(targetCount / items.length);

      for (let i = 1; i < iterationsNeeded; i++) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('cm-js-duplicate');

          const img = clone.querySelector('img');
          if (img) {
            img.setAttribute('loading', 'eager');
            img.setAttribute('fetchpriority', 'auto');
          }

          wrapper.appendChild(clone);
        });
      }
    }
  };

  const smoothScroll = () => {
    if (window.innerWidth < desktopBreakpoint) {
      stopLoop();
      return;
    }

    const firstItem = wrapper.firstElementChild;
    if (!firstItem) return;

    const width = firstItem.getBoundingClientRect().width;
    const duration = 10000;

    wrapper.style.transition = `margin-left ${duration}ms linear`;
    wrapper.style.marginLeft = `-${width}px`;

    animationTimeout = setTimeout(() => {
      if (window.innerWidth >= desktopBreakpoint) {
        wrapper.style.transition = 'none';
        wrapper.appendChild(firstItem);
        wrapper.style.marginLeft = '0';
        animationTimeout = setTimeout(smoothScroll, 50);
      } else {
        stopLoop();
      }
    }, duration);
  };

  const stopLoop = () => {
    isLooping = false;
    clearTimeout(animationTimeout);
    wrapper.style.transition = 'none';
    wrapper.style.marginLeft = '0';
    wrapper.querySelectorAll('.cm-js-duplicate').forEach(el => el.remove());
  };

  const initLoop = () => {
    const items = wrapper.querySelectorAll('.cm-media-item:not(.cm-js-duplicate)');
    if (window.innerWidth >= desktopBreakpoint && !isLooping && items.length > 1) {
      isLooping = true;
      setupInfiniteLoop();
      smoothScroll();
    } else if (window.innerWidth < desktopBreakpoint && isLooping) {
      stopLoop();
    }
  };

  initLoop();
  window.addEventListener('resize', initLoop);
}

/**
 * 8. IMAGE ZOOM LOGIK
 */
function initProductZoom() {
  const lightbox = document.getElementById('cm-image-lightbox');
  if (!lightbox) return;

  const isEnabled = lightbox.getAttribute('data-enable-zoom') === 'true';
  if (!isEnabled) return;

  const lightboxImg = document.getElementById('cm-lightbox-img');
  const wrapper = document.querySelector('.cm-media-wrapper');
  if (!lightboxImg || !wrapper) return;

  const closeBtn = lightbox.querySelector('.cm-lightbox-close');

  let currentImgIndex = 0;
  let zoomSrcList = [];

  let isDragging = false;
  let hasMoved = false;
  let startX, startY;
  let scrollStartX, scrollStartY;
  let pos = { x: 0, y: 0 };
  const zoomLevel = 4;

  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;

  if (!lightbox.querySelector('.cm-lightbox-prev')) {
    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'cm-slider-nav cm-prev cm-lightbox-nav cm-lightbox-prev';
    prevBtn.setAttribute('aria-label', 'Forrige billede');
    const originalPrevIcon = document.querySelector('.cm-slider-nav.cm-prev svg');
    if (originalPrevIcon) {
      prevBtn.appendChild(originalPrevIcon.cloneNode(true));
    } else {
      prevBtn.innerHTML = '&#10229;';
    }
    lightbox.appendChild(prevBtn);

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'cm-slider-nav cm-next cm-lightbox-nav cm-lightbox-next';
    nextBtn.setAttribute('aria-label', 'Næste billede');
    const originalNextIcon = document.querySelector('.cm-slider-nav.cm-next svg');
    if (originalNextIcon) {
      nextBtn.appendChild(originalNextIcon.cloneNode(true));
    } else {
      nextBtn.innerHTML = '&#10230;';
    }
    lightbox.appendChild(nextBtn);

    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); navigateLightbox(-1); });
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); navigateLightbox(1); });
  }

  function navigateLightbox(direction) {
    if (lightboxImg.classList.contains('cm-is-zoomed')) {
      resetImage();
    }

    lightboxImg.style.transition = 'opacity 0.15s ease-in-out';
    lightboxImg.style.opacity = '0';

    setTimeout(() => {
      currentImgIndex += direction;
      if (currentImgIndex >= zoomSrcList.length) currentImgIndex = 0;
      if (currentImgIndex < 0) currentImgIndex = zoomSrcList.length - 1;

      lightboxImg.src = zoomSrcList[currentImgIndex];

      lightboxImg.onload = function() {
        lightboxImg.style.transition = 'opacity 0.2s ease-in-out';
        lightboxImg.style.opacity = '1';
      };

      if (lightboxImg.complete) {
        lightboxImg.style.transition = 'opacity 0.2s ease-in-out';
        lightboxImg.style.opacity = '1';
      }

    }, 150);
  }

  wrapper.addEventListener('click', (e) => {
    const item = e.target.closest('.cm-media-item');
    if (!item || e.target.closest('.cm-slider-nav') || e.target.closest('#cm-open-collection-drawer-mobile')) return;

    const allItems = Array.from(wrapper.querySelectorAll('.cm-media-item:not(.cm-js-duplicate)'));
    zoomSrcList = allItems.map(el => el.getAttribute('data-zoom-src')).filter(src => src);

    const zoomUrl = item.getAttribute('data-zoom-src');
    currentImgIndex = zoomSrcList.indexOf(zoomUrl);

    if (zoomUrl && currentImgIndex !== -1) {
      lightbox.style.display = "block";
      lightboxImg.style.transition = 'none';
      lightboxImg.style.transform = 'translate3d(0, 0, 0)';
      lightboxImg.style.opacity = '1';
      lightboxImg.src = zoomUrl;
      document.body.style.overflow = 'hidden';
      resetImage();
    }
  });

  window.addEventListener('keydown', (e) => {
    if (lightbox.style.display !== "block") return;
    if (e.key === "Escape") {
      closeLightbox();
    } else if (e.key === "ArrowRight") {
      navigateLightbox(1);
    } else if (e.key === "ArrowLeft") {
      navigateLightbox(-1);
    }
  });

  lightboxImg.addEventListener('click', (e) => {
    e.stopPropagation();
    if (hasMoved) return;

    const isNowZoomed = lightboxImg.classList.toggle('cm-is-zoomed');
    if (isNowZoomed) {
      updateImagePosition(true);
      lightbox.classList.add('cm-lightbox--zoomed');
    } else {
      resetImage();
    }
  });

  lightbox.addEventListener('touchstart', (e) => {
    if (lightboxImg.classList.contains('cm-is-zoomed')) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  lightbox.addEventListener('touchmove', (e) => {
    if (lightboxImg.classList.contains('cm-is-zoomed')) return;
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;
  }, { passive: true });

  lightbox.addEventListener('touchend', () => {
    if (lightboxImg.classList.contains('cm-is-zoomed')) return;

    const xDiff = touchStartX - touchEndX;
    const yDiff = touchStartY - touchEndY;
    const minSwipeDistance = 50;

    if (Math.abs(xDiff) > Math.abs(yDiff) && Math.abs(xDiff) > minSwipeDistance) {
      if (xDiff > 0) {
        navigateLightbox(1);
      } else {
        navigateLightbox(-1);
      }
    }
    touchStartX = 0; touchEndX = 0; touchStartY = 0; touchEndY = 0;
  });

  const handleStart = (e) => {
    if (!lightboxImg.classList.contains('cm-is-zoomed')) return;
    isDragging = true;
    hasMoved = false;
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    scrollStartX = clientX;
    scrollStartY = clientY;
    startX = clientX - pos.x;
    startY = clientY - pos.y;
    lightboxImg.style.transition = 'none';
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    if (Math.abs(clientX - scrollStartX) > 5 || Math.abs(clientY - scrollStartY) > 5) {
      hasMoved = true;
    }
    if (!hasMoved) return;
    pos.x = clientX - startX;
    pos.y = clientY - startY;
    updateImagePosition(true);
  };

  const handleEnd = () => {
    isDragging = false;
    if (lightboxImg.classList.contains('cm-is-zoomed')) {
      lightboxImg.style.transition = 'transform 0.3s ease-out';
    }
  };

  function updateImagePosition(withZoom = false) {
    const scaleValue = withZoom ? zoomLevel : 1;
    lightboxImg.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0) scale(${scaleValue})`;
  }

  function resetImage() {
    pos = { x: 0, y: 0 };
    hasMoved = false;
    lightboxImg.classList.remove('cm-is-zoomed');
    lightbox.classList.remove('cm-lightbox--zoomed');
    lightboxImg.style.transform = `translate3d(0, 0, 0) scale(1)`;
  }

  lightboxImg.addEventListener('mousedown', handleStart);
  window.addEventListener('mousemove', handleMove);
  window.addEventListener('mouseup', handleEnd);
  lightboxImg.addEventListener('touchstart', handleStart, { passive: true });
  window.addEventListener('touchmove', handleMove, { passive: false });
  window.addEventListener('touchend', handleEnd);

  const closeLightbox = () => {
    lightbox.style.display = "none";
    document.body.style.overflow = '';
    resetImage();
  };

  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => {
    if (e.target !== lightboxImg && !e.target.closest('.cm-lightbox-nav')) closeLightbox();
  });
}

/**
 * INITIALISER ALLE FUNKTIONER NÅR DOM'EN ER KLAR
 */
document.addEventListener('DOMContentLoaded', () => {
  initProductSlider();
  initBundleDrawer();
  initStoreStock();
  initCollectionDrawer();
  initShopLookDrawer();
  initMtmDrawer();
  initProductInfiniteLoop();
  initProductZoom();
});
